import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { Event, EventSubscription } from '../../entities/events/event';
import * as fromGraphQl from './graphql';
import { SubscriptionsComponent } from './subscriptions.component';

export class EventSubscriptionsDataSource extends NXDataSourcePrime<Event> {
  constructor(apollo: Apollo,
    @Inject('env') environment: any,
    private subscriptionsComponent: SubscriptionsComponent
    ) {
    super(apollo, fromGraphQl.EVENT_SUBSCRIPTION_QUERY, environment);
  }
  public selectedEventSubscription: EventSubscription;

  handleSubscriptionResult(data: fromGraphQl.EventSubscriptionsQueryResponse): void {
    super.setSubject(
      data?.eventSubscriptions?.content ? EventSubscription.createEventSubscription(data?.eventSubscriptions?.content) : [],
      data?.eventSubscriptions?.totalElements ? data?.eventSubscriptions.totalElements : 0
    );
    if (data?.eventSubscriptions?.totalElements > 0) {
      if(!this.selectedEventSubscription) {
        this.selectedEventSubscription = new EventSubscription(data?.eventSubscriptions?.content[0]);
        this.subscriptionsComponent.setMenuItems();
      }
    }
    else {
      this.selectedEventSubscription = undefined;
    }
    this.querySubscription?.unsubscribe();
  }

  loadEvents(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
